export default function getNavigatorLocale() {
    const rawLocale = navigator.languages?.[0] || navigator.language || 'en-GB';
    return cleanLocale(rawLocale);
}

function cleanLocale(locale) {
  if (!locale) return 'en-GB';
  // Remove quality values (;q=0.9) and other parameters
  return locale.split(';')[0].split(',')[0].trim();
}